const GetCategoryForumConfigReducer = (state = { type: 'LOADING_CATEGORY_FORUM_CONFIG_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_CATEGORY_FORUM_CONFIG_ACTION':
            return action
        case 'RESET_CATEGORY_FORUM_CONFIG_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetCategoryForumTableReducer = (state = { type: 'LOADING_CATEGORY_FORUM_TABLE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_CATEGORY_FORUM_TABLE_ACTION':
            return action
        case 'RESET_CATEGORY_FORUM_TABLE_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetCategoryForumYearToDateReducer = (state = { type: 'LOADING_CATEGORY_FORUM_YEAR_TO_DATE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CATEGORY_FORUM_YEAR_TO_DATE_ACTION':
            return { ...state, type: 'LOADING_CATEGORY_FORUM_YEAR_TO_DATE_ACTION', loading: true };
        case 'SUCCESS_CATEGORY_FORUM_YEAR_TO_DATE_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CATEGORY_FORUM_YEAR_TO_DATE_ACTION':
            return { ...state, type: 'ERROR_CATEGORY_FORUM_YEAR_TO_DATE_ACTION', loading: false, error: action.error };
        case 'RESET_CATEGORY_FORUM_YEAR_TO_DATE_ACTION':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}

const GetCategoryForumForumsByCategoryReducer = (state = { type: 'LOADING_CATEGORY_FORUM_FORUMS_BY_CATEGORY_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CATEGORY_FORUM_FORUMS_BY_CATEGORY_ACTION':
            return { ...state, type: 'LOADING_CATEGORY_FORUM_FORUMS_BY_CATEGORY_ACTION', loading: true };
        case 'SUCCESS_CATEGORY_FORUM_FORUMS_BY_CATEGORY_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CATEGORY_FORUM_FORUMS_BY_CATEGORY_ACTION':
            return { ...state, type: 'ERROR_CATEGORY_FORUM_FORUMS_BY_CATEGORY_ACTION', loading: false, error: action.error };
        case 'RESET_CATEGORY_FORUM_FORUMS_BY_CATEGORY_ACTION':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}

const GetCategoryForumBalanceOfTheYearReducer = (state = { type: 'LOADING_CATEGORY_FORUM_BALANCE_OF_THE_YEAR_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CATEGORY_FORUM_BALANCE_OF_THE_YEAR_ACTION':
            return { ...state, type: 'LOADING_CATEGORY_FORUM_BALANCE_OF_THE_YEAR_ACTION', loading: true };
        case 'SUCCESS_CATEGORY_FORUM_BALANCE_OF_THE_YEAR_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CATEGORY_FORUM_BALANCE_OF_THE_YEAR_ACTION':
            return { ...state, type: 'ERROR_CATEGORY_FORUM_BALANCE_OF_THE_YEAR_ACTION', loading: false, error: action.error };
        case 'RESET_CATEGORY_FORUM_BALANCE_OF_THE_YEAR_ACTION':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}

const GetCategoryForumSummaryReducer = (state = { type: 'LOADING_CATEGORY_FORUM_SUMMARY_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CATEGORY_FORUM_SUMMARY_ACTION':
            return { ...state, type: 'LOADING_CATEGORY_FORUM_SUMMARY_ACTION', loading: true };
        case 'SUCCESS_CATEGORY_FORUM_SUMMARY_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CATEGORY_FORUM_SUMMARY_ACTION':
            return { ...state, type: 'ERROR_CATEGORY_FORUM_SUMMARY_ACTION', loading: false, error: action.error };
        case 'RESET_CATEGORY_FORUM_SUMMARY_ACTION':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}

// const GetCategoryForumContractBoardsDetailsReducer = (state = { type: 'LOADING_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION', data: {} }, action) => {
//     switch (action.type) {
//         case 'SUCCESS_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION':
//             return action
//         case 'RESET_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION':
//             return {
//                 ...state,
//                 type: action.payload
//             };
//         default:
//             return state
//     }
// }

const GetCategoryForumContractBoardsDetailsReducer = (state = { type: 'LOADING_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION':
            return { ...state, type: 'LOADING_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION', loading: true };
        case 'SUCCESS_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION':
            return { ...state, type: 'ERROR_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION', loading: false, error: action.error };
        case 'RESET_CATEGORY_FORUM_CONTRACT_BOARDS_DETAILS_ACTION':
            return {
                ...state,
                type: action.payload
            };    
        default:
            return state
    }
}

const GetCategoryForumActionTrackerFiltersReducer = (state = { type: 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_FILTERS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_FILTERS_ACTION':
            return { ...state, type: 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_FILTERS_ACTION', loading: true };
        case 'SUCCESS_CATEGORY_FORUM_ACTION_TRACKER_FILTERS_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CATEGORY_FORUM_ACTION_TRACKER_FILTERS_ACTION':
            return { ...state, type: 'ERROR_CATEGORY_FORUM_ACTION_TRACKER_FILTERS_ACTION', loading: false, error: action.error };
        default:
            return state;
    }
}

const GetCategoryForumActionTrackerHeaderDataReducer = (state = { type: 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_HEADER_DATA_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_HEADER_DATA_ACTION':
            return { ...state, type: 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_HEADER_DATA_ACTION', loading: true };
        case 'SUCCESS_CATEGORY_FORUM_ACTION_TRACKER_HEADER_DATA_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CATEGORY_FORUM_ACTION_TRACKER_HEADER_DATA_ACTION':
            return { ...state, type: 'ERROR_CATEGORY_FORUM_ACTION_TRACKER_HEADER_DATA_ACTION', loading: false, error: action.error };
        default:
            return state;
    }
}

const GetCategoryForumActionTrackerTabularDataReducer = (state = { type: 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_TABULAR_DATA_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_TABULAR_DATA_ACTION':
            return { ...state, type: 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_TABULAR_DATA_ACTION', loading: true };
        case 'SUCCESS_CATEGORY_FORUM_ACTION_TRACKER_TABULAR_DATA_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CATEGORY_FORUM_ACTION_TRACKER_TABULAR_DATA_ACTION':
            return { ...state, type: 'ERROR_CATEGORY_FORUM_ACTION_TRACKER_TABULAR_DATA_ACTION', loading: false, error: action.error };
        default:
            return state;
    }
}

const GetCategoryForumActionTrackerChartDataReducer = (state = { type: 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_CHART_DATA_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_CHART_DATA_ACTION':
            return { ...state, type: 'LOADING_CATEGORY_FORUM_ACTION_TRACKER_CHART_DATA_ACTION', loading: true };
        case 'SUCCESS_CATEGORY_FORUM_ACTION_TRACKER_CHART_DATA_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CATEGORY_FORUM_ACTION_TRACKER_CHART_DATA_ACTION':
            return { ...state, type: 'ERROR_CATEGORY_FORUM_ACTION_TRACKER_CHART_DATA_ACTION', loading: false, error: action.error };
        default:
            return state;
    }
}

const GetCategoryForumOutcomeSummaryFiltersReducer = (state = { type: 'LOADING_CATEGORY_FORUM_OUTCOME_SUMMARY_FILTERS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CATEGORY_FORUM_OUTCOME_SUMMARY_FILTERS_ACTION':
            return { ...state, type: 'LOADING_CATEGORY_FORUM_OUTCOME_SUMMARY_FILTERS_ACTION', loading: true };
        case 'SUCCESS_CATEGORY_FORUM_OUTCOME_SUMMARY_FILTERS_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CATEGORY_FORUM_OUTCOME_SUMMARY_FILTERS_ACTION':
            return { ...state, type: 'ERROR_CATEGORY_FORUM_OUTCOME_SUMMARY_FILTERS_ACTION', loading: false, error: action.error };
        default:
            return state;
    }
}

const GetCategoryForumOutcomeSummaryTabularDataReducer = (state = { type: 'LOADING_CATEGORY_FORUM_OUTCOME_SUMMARY_TABULAR_DATA_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_CATEGORY_FORUM_OUTCOME_SUMMARY_TABULAR_DATA_ACTION':
            return { ...state, type: 'LOADING_CATEGORY_FORUM_OUTCOME_SUMMARY_TABULAR_DATA_ACTION', loading: true };
        case 'SUCCESS_CATEGORY_FORUM_OUTCOME_SUMMARY_TABULAR_DATA_ACTION':
            return { ...action, loading: false };
        case 'ERROR_CATEGORY_FORUM_OUTCOME_SUMMARY_TABULAR_DATA_ACTION':
            return { ...state, type: 'ERROR_CATEGORY_FORUM_OUTCOME_SUMMARY_TABULAR_DATA_ACTION', loading: false, error: action.error };
        default:
            return state;
    }
}

const GetYourCategoryForumUserCalendarReducer = (state = { type: 'LOADING_YOUR_CATEGORY_FORUM_USER_CALENDAR_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_YOUR_CATEGORY_FORUM_USER_CALENDAR_ACTION':
            return { ...state, type: 'LOADING_YOUR_CATEGORY_FORUM_USER_CALENDAR_ACTION', loading: true };
        case 'SUCCESS_YOUR_CATEGORY_FORUM_USER_CALENDAR_ACTION':
            return { ...action, loading: false };
        case 'ERROR_YOUR_CATEGORY_FORUM_USER_CALENDAR_ACTION':
            return { ...state, type: 'ERROR_YOUR_CATEGORY_FORUM_USER_CALENDAR_ACTION', loading: false, error: action.error };
        default:
            return state;
    }
}

export {
    GetCategoryForumConfigReducer,
    GetCategoryForumTableReducer,
    GetCategoryForumYearToDateReducer,
    GetCategoryForumForumsByCategoryReducer,
    GetCategoryForumBalanceOfTheYearReducer,
    GetCategoryForumSummaryReducer,
    GetCategoryForumContractBoardsDetailsReducer,
    GetCategoryForumActionTrackerFiltersReducer,
    GetCategoryForumActionTrackerHeaderDataReducer,
    GetCategoryForumActionTrackerTabularDataReducer,
    GetCategoryForumActionTrackerChartDataReducer,
    GetCategoryForumOutcomeSummaryFiltersReducer,
    GetCategoryForumOutcomeSummaryTabularDataReducer,
    GetYourCategoryForumUserCalendarReducer
}